<template>
    <FormSection title="Preadmission Notes" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2" :style="{ width: isPreadmissionDialog ? '900px' : '' }">
                <PatientPreadmissionNotesForm
                    v-if="showNoteForm"
                    :application="application"
                    :is-referral="isReferral"
                    :referral-id="referralId"
                    :reset-list="resetList"
                    :referral="referral"
                    :closeNoteFormProp="closeNoteForm"
                    ref="preadmissionForm"
                    class="mb-2"
                />
                <div class="d-flex justify-content-end" v-if="!showNoteForm">
                    <button class="btn btn-primary ms-2 mb-2" @click="openNoteForm()" v-if="isReferral">
                        Add Preadmission Note
                    </button>
                </div>
                <Pagination ref="notesList" :page-changed="pageChangedCallback" :is-loading="isLoading">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header">
                                <th>Title</th>
                                <th>Date</th>
                                <th>User</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="isLoading || isError || !hasData">
                            <!-- LOADING -->
                            <tr v-for="i of loadingCount" class="table-loading" v-if="isLoading">
                                <td v-for="i of columns">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Preadmission Notes.</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Preadmission Notes" :try-again="resetList" />
                                </td>
                            </tr>
                        </tbody>
                        <PatientPreadmissionNotesRow
                            v-else
                            v-for="note of page.items"
                            :note="note"
                            :is-referral="isReferral"
                            :columns="columns"
                            :reset-list="resetList"
                            :referral-id="referralId"
                            :referral="referral"
                        />
                    </table>
                </Pagination>
                <footer v-if="isPreadmissionDialog" class="d-flex justify-content-center">
                    <button @click="closeDialog()" type="button" class="btn btn-xs me-2 btn-outline-primary">
                        Close
                    </button>
                </footer>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./PatientPreadmissionNotes.ts"></script>
